import React from 'react';
import { STATS, FEATURES, DIFFERENCE_ITEMS, LEARN_CARDS, PLATFORMS } from '../mock';
import * as Icons from 'lucide-react';
import { CheckCircle2, ArrowRight, Sparkles } from 'lucide-react';

export const StatsBar = () => (
  <section className="py-16 border-y border-[#141f1b] bg-[#070c0a]">
    <div className="max-w-[1400px] mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8">
      {STATS.map(s => (
        <div key={s.label} className="text-center">
          <div className="text-3xl md:text-5xl font-extrabold text-[#00e676] mono">{s.value}</div>
          <div className="mt-2 text-sm text-gray-400">{s.label}</div>
        </div>
      ))}
    </div>
  </section>
);

export const BonusBanner = () => (
  <section className="py-20 relative overflow-hidden">
    <div className="absolute inset-0 hero-glow opacity-70"/>
    <div className="relative max-w-[1200px] mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
      <div>
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#00e676]/10 border border-[#00e676]/30 text-[#00e676] text-xs font-semibold mb-4">
          <Sparkles size={14}/> WELCOME BONUS
        </div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-white leading-tight">
          100% Bonus on Your<br/><span className="text-[#00e676]">First Deposit</span>
        </h2>
        <p className="mt-4 text-gray-400">Plus <span className="text-white font-semibold">50% Extra</span> Every Time You Top Up*</p>
        <button className="btn-green mt-6 px-8 py-3.5 rounded-full font-semibold">Open Account Now →</button>
      </div>
      <div className="relative">
        <div className="grid grid-cols-2 gap-4">
          {[
            { v: '+$1,000', l: 'BONUS' },
            { v: '+100%', l: 'WINNER' },
            { v: '50%', l: 'RELOAD' },
            { v: '0.0', l: 'SPREAD' }
          ].map((b) => (
            <div key={b.l} className="p-6 rounded-2xl border border-[#1a2823] bg-[#0a1210] feature-card">
              <div className="text-3xl font-extrabold text-[#00e676] mono">{b.v}</div>
              <div className="mt-1 text-xs text-gray-400 font-semibold tracking-wider">{b.l}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export const Features = () => (
  <section className="py-24 relative">
    <div className="max-w-[1400px] mx-auto px-6">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <div className="text-xs font-semibold tracking-widest text-[#00e676] mb-3">WHY NEXUS FX PRO</div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-white">Built for Serious Traders</h2>
        <p className="mt-4 text-gray-400">Institutional infrastructure, retail accessibility.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {FEATURES.map(f => {
          const Ico = Icons[f.icon] || Icons.Circle;
          return (
            <div key={f.title} className="feature-card p-7 rounded-2xl border border-[#1a2823] bg-[#0a1210]">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-[#00e676]/10 border border-[#00e676]/30 flex items-center justify-center text-[#00e676]">
                  <Ico size={18}/>
                </div>
                <span className="text-xs font-semibold text-[#00e676] tracking-wider">{f.tag}</span>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{f.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{f.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export const PlatformsSection = () => (
  <section className="py-24 relative border-y border-[#141f1b] bg-[#070c0a]">
    <div className="max-w-[1400px] mx-auto px-6">
      <div className="max-w-3xl mb-14">
        <div className="text-xs font-semibold tracking-widest text-[#00e676] mb-3">AWARD-WINNING TECH</div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-white">Institutional-Grade CFD Trading Platforms</h2>
        <p className="mt-4 text-gray-400 text-lg">Whether you scalp intraday volatility or run systematic strategies, our desktop, WebTrader and mobile apps are tuned for speed, stability, and control.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {PLATFORMS.map(p => (
          <div key={p.title} className="feature-card p-6 rounded-xl border border-[#1a2823] bg-[#0a1210]">
            <div className="w-10 h-10 rounded-lg bg-[#00e676]/10 border border-[#00e676]/30 flex items-center justify-center text-[#00e676] mb-4">
              <Icons.Monitor size={18}/>
            </div>
            <h3 className="font-bold text-white mb-2">{p.title}</h3>
            <p className="text-sm text-gray-400">{p.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const Difference = () => (
  <section className="py-24 relative overflow-hidden">
    <div className="absolute inset-0 grid-bg opacity-20"/>
    <div className="relative max-w-[1400px] mx-auto px-6">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <div className="text-xs font-semibold tracking-widest text-[#00e676] mb-3">THE NEXUS FX PRO DIFFERENCE</div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-white">Why Traders Choose Us</h2>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {DIFFERENCE_ITEMS.map((d, i) => (
          <div key={d.title} className="feature-card p-7 rounded-2xl border border-[#1a2823] bg-[#0a1210]">
            <div className="text-4xl font-extrabold text-[#00e676]/20 mono mb-2">0{i+1}</div>
            <h3 className="text-lg font-bold text-white mb-2">{d.title}</h3>
            <p className="text-sm text-gray-400 leading-relaxed">{d.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const LearnSection = () => (
  <section className="py-24 border-y border-[#141f1b] bg-[#070c0a]">
    <div className="max-w-[1400px] mx-auto px-6">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <div className="text-xs font-semibold tracking-widest text-[#00e676] mb-3">EDUCATION</div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-white">Learn. Trade. Grow.</h2>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {LEARN_CARDS.map(l => (
          <div key={l.title} className="feature-card p-8 rounded-2xl border border-[#1a2823] bg-[#0a1210]">
            <div className="text-xs font-bold text-[#00e676] tracking-widest mb-4">{l.tag}</div>
            <h3 className="text-2xl font-bold text-white mb-3">{l.title}</h3>
            <p className="text-sm text-gray-400 leading-relaxed mb-6">{l.desc}</p>
            <button className="inline-flex items-center gap-1.5 text-[#00e676] font-semibold text-sm hover:gap-2.5 transition-all">
              {l.cta} <ArrowRight size={14}/>
            </button>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const CTA = () => (
  <section className="py-24 relative overflow-hidden">
    <div className="absolute inset-0 hero-glow"/>
    <div className="relative max-w-[900px] mx-auto px-6 text-center">
      <h2 className="text-4xl md:text-6xl font-extrabold text-white leading-tight">
        Ready to Trade with a<br/><span className="text-[#00e676]">True Institutional Edge?</span>
      </h2>
      <p className="mt-6 text-lg text-gray-400">Join 27,000+ active traders and experience execution, pricing, and support that feel closer to a prop desk than a retail broker.</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
        <a href="/dashboard" className="btn-green px-8 py-3.5 rounded-full font-semibold">Open Live Account</a>
        <a href="#" className="btn-outline-green px-8 py-3.5 rounded-full font-semibold">Speak to an Expert</a>
      </div>
      <div className="mt-10 flex flex-wrap items-center justify-center gap-8 text-gray-400 text-sm">
        <div className="flex items-center gap-2"><CheckCircle2 size={16} className="text-[#00e676]"/> 24/7 Support</div>
        <div className="flex items-center gap-2"><CheckCircle2 size={16} className="text-[#00e676]"/> Multilingual Experts</div>
        <div className="flex items-center gap-2"><CheckCircle2 size={16} className="text-[#00e676]"/> 150+ Countries</div>
      </div>
    </div>
  </section>
);
